module.exports = __webpack_public_path__ + "static/media/redRing.4377fc2c.svg";